import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UniversalSearchModel, UniversalSearchModelType } from 'src/app/core/models/universal-search.model';
import { AuthenticationService } from 'src/app/core/services';
import { AccountIntentTopic } from 'src/app/shared/dto';
import { FeatureFlagsEnum, IntentSourceEnum, REQUEST_TYPE, ResultTabsetUrlsEnum } from 'src/app/shared/enums';
import { cloneDeep } from 'lodash-es';

@Component({
    selector: 'app-intent-surge',
    templateUrl: './intent-surge.component.html',
    styleUrls: ['./intent-surge.component.scss'],
    standalone: false
})
export class IntentSurgeComponent {
    @Input() topicsPredictiveIntent: AccountIntentTopic[];
    @Input() topicsBombora: AccountIntentTopic[];
    @Input() surgeCount: Record<string, number>;
    @Input() isLoading: boolean;
    @Input() isAdmin: boolean;
    @Input() adminEmail: string;
    @Output() searchTrigger = new EventEmitter();

    readonly intentSourceEnum: typeof IntentSourceEnum = IntentSourceEnum;
    readonly featureFlagsEnum = FeatureFlagsEnum;
    readonly resultTabsetUrlsEnum = ResultTabsetUrlsEnum;

    constructor(private readonly authenticationService: AuthenticationService) { }

    navigateToSearch(intentSource: IntentSourceEnum) {
        const searchModelData: UniversalSearchModelType = {
            ...cloneDeep(UniversalSearchModel),
            request_type: REQUEST_TYPE.COMPANIES,
            page: 1,
            verified: 1,
            tiers: this.authenticationService.getHumanVerifiedTiers().toString(),
            ...(intentSource === IntentSourceEnum.BOMBORA
                ? { intent_topic_ids: this.topicsBombora.map((topic: AccountIntentTopic) => topic.topic_id) }
                : { si_intent_topic_ids: this.topicsPredictiveIntent.map((topic: AccountIntentTopic) => topic.topic_id) })
        }
        this.searchTrigger.emit(searchModelData);
    }

}
